<app-spinner [isActive]="submitIsActive"></app-spinner>
<div class="modal-body">
  <div class="card">
    <div class="modal-header modal-close">
      <button type="button" class="close" aria-label="Close" (click)="closeModal()"><span
        aria-hidden="true">&times;</span></button>
    </div>
    <div class="card-header modal-card-header">
      <h4 class="card-title" id="basic-layout-form">{{ 'paymentRequest.title' | translate }}</h4>
      <p class="mb-0">{{ 'paymentRequest.text' | translate }}</p>
    </div>
    <div class="card-body">
      <div [class]="hasDesktopView ? 'px-3' : 'px-2'">
        <form class="form" #paymentRequestForm="ngForm" (ngSubmit)="onSubmit(paymentRequestForm)">
          <div class="form-body">
            <h4 class="form-section">
              <i class="ft-cpu"></i> {{ 'paymentRequest.detailsHeader' | translate }}
            </h4>

            <!-- PaymentRequestId -->
            <div class="form-group">
              <label for="PaymentRequestId">{{ 'paymentRequest.paymentRequestIdFieldLabel' | translate }}</label>
              <input class="form-control" name="PaymentRequestId" #PaymentRequestId="ngModel"
                     [(ngModel)]="currentObject.PaymentRequestId"
                     placeholder="{{'paymentRequest.paymentRequestIdFieldPlaceHolder' | translate}}"
                     readonly="readonly">
            </div>

            <!-- Remittance Information -->
            <div class="form-group">
              <label
                for="RemittanceInformation">{{ 'paymentRequest.remittanceInformationFieldLabel' | translate }}</label>
              <textarea [readonly]="isReadOnly"
                        class="form-control"
                        name="RemittanceInformation"
                        #RemittanceInformation="ngModel"
                        [(ngModel)]="currentObject.RemittanceInformation"
                        placeholder="{{'paymentRequest.remittanceInformationFieldPlaceHolder' | translate}}"
                        rows="2"
                        required
                        maxlength="140"
                        pattern="^[a-zA-Z0-9\s/?:().,'+-]+$"
                        (input)=descriptionChanged()>
              </textarea>
              <small>{{ descriptionLength }}/140</small>
              <small class="form-text text-danger"
                     *ngIf="RemittanceInformation.errors?.required && (RemittanceInformation.dirty || RemittanceInformation.touched)">
                {{ 'paymentRequest.remittanceInformationRequiredText' | translate }}
              </small>

              <small class="form-text text-danger"
                     *ngIf="RemittanceInformation.errors?.maxlength && (RemittanceInformation.dirty || RemittanceInformation.touched)">
                {{ 'paymentRequest.remittanceInformationLengthText' | translate }}
              </small>

              <small class="form-text text-danger"
                     *ngIf="RemittanceInformation.errors?.pattern && (RemittanceInformation.dirty || RemittanceInformation.touched)">
                {{ 'payment.descriptionAllowedCharactersText' | translate }}
              </small>
            </div>

            <!-- Amount -->
            <div class="form-group">
              <label for="Amount">{{ 'paymentRequest.amountFieldLabel' | translate }}</label>
              <div class="input-group">
                <div class="input-group-prepend">
                  <span class="input-group-text">€</span>
                </div>
                <input type="number" min="0" max="99999" class="form-control payment-request-input col-md-2"
                       name="Amount" #Amount="ngModel" [(ngModel)]="amount"
                       placeholder="{{'paymentRequest.amountFieldPlaceHolder' | translate}}" [readonly]="isReadOnly"
                       required minlength="1" maxlength="5"
                       pattern="^([1-9]\d{0,4})(?!.*[#$^_.,/?;:+=!*()@%&])$"/>
                <div class="input-group-append">
                  <span class="input-group-text">,</span>
                </div>
                <input type="number" min="0" max="99" class="form-control payment-request-decimal-input col-md-1"
                       name="SmallAmount" #SmallAmount="ngModel" [(ngModel)]="smallAmount"
                       [readonly]="isReadOnly" required minlength="0" maxlength="2"
                       pattern="^([0-9]\d{0,1})(?!.*[#$^_.,\/?;:+=!*()@%&])$">
              </div>
            </div>
            <small class="form-text text-muted danger"
                   *ngIf="(((Amount.value <= 0) || !Amount.valid) && (Amount.dirty || Amount.touched)) || (((SmallAmount < 0) || (SmallAmount > 99) || !SmallAmount.valid) && (SmallAmount.dirty || SmallAmount.touched))">
              {{ 'paymentRequest.amountInformationText' | translate }}
            </small>
          </div>
          <div class="form-actions">
            <button [hidden]="isReadOnly" class="btn btn-raised btn-raised btn-warning mr-1" type="button"
                    (click)="resetForm(paymentRequestForm)">
              <i class="ft-x"></i> {{ 'buttons.resetText' | translate }}
            </button>
            <button [hidden]="isReadOnly" [disabled]="!paymentRequestForm.valid || !hasValidAmount()"
                    class="btn btn-raised btn-raised btn-primary mr-1" type="submit">
              <i class="ft-check-square"></i> {{ 'buttons.saveText' | translate }}
            </button>
            <button type="button" class="btn btn-secondary btn-raised mr-1" (click)="closeModal()">
              <i class="ft-x-square"></i> {{ 'buttons.closeText' | translate }}
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
